// extracted by mini-css-extract-plugin
export default {"announcements":"Announcements_announcements__2dsKt"};